import {getArchivedTooltipMessage} from 'analysis-tool/AnalysisToolMessages';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {refreshAnalysis} from 'analysis-tool/polling/refreshPipeline';
import {
  AnalysisRightSidebarItem,
  AnalysisRightSidebarItemType,
} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {recordAnalysisAction} from 'analysis-tool/ui/debugAnalysisActionHistory';
import isArchived from 'archive/isArchived';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {addStepWithInferredEdges} from 'pipelines/network/addStepWithInferredEdges';
import {getTemplateOutputStepConfig} from 'pipelines/PipelineConfigConstants';
import {PipelineGraphQL, PipelineViewGraphQL} from 'pipelines/PipelineTypes';
import {isDataFrameView, resolveLineageStep, resolveOutputStepData} from 'pipelines/PipelineViewUtils';
import {withLoadingScreen} from 'util/Promises';

export default function getExportDatasetAction(
  analysis: PipelineGraphQL,
  view: PipelineViewGraphQL,
  onChangeSelectedRightSidebarItem: (newSelectedItem: AnalysisRightSidebarItem | null) => void
): OverflowDataViewAction | null {
  if (isAnalysisReadOnly(analysis) || !isDataFrameView(view, analysis.steps)) {
    return null;
  }

  const lastNode = view.lineage[view.lineage.length - 1];
  if (lastNode.stepOutputReference == null) {
    return null;
  }
  const outputStepData = resolveOutputStepData(analysis.steps, {
    step: lastNode.step,
    stepOutputReference: lastNode.stepOutputReference,
  });
  if (outputStepData.rawDatas.length === 0) {
    return null;
  }

  return {
    icon: 'dataset',
    label: 'Export as dataset',
    isDisabled: isArchived(analysis),
    helpText: isArchived(analysis) ? getArchivedTooltipMessage(analysis) : undefined,
    onClick: async () => {
      const lastStep = resolveLineageStep(analysis.steps, lastNode);
      recordAnalysisAction('EXPORT_DATASET', {
        analysisId: analysis.id,
        stepId: lastStep.id,
        stepType: lastStep.stepType,
      });
      const {stepId} = await withLoadingScreen(
        addStepWithInferredEdges(analysis, {
          stepType: PipelineStepType.EXPORT_DATA_CATALOG_DATASET,
          stepData: outputStepData,
          createBranch: true,
          config: getTemplateOutputStepConfig(analysis, PipelineStepType.EXPORT_DATA_CATALOG_DATASET),
        })
      );
      await withLoadingScreen(refreshAnalysis(analysis.id));
      onChangeSelectedRightSidebarItem({
        type: AnalysisRightSidebarItemType.EDIT_STEP,
        stepId,
      });
    },
  };
}
